import { motion } from 'framer-motion';
import { cn } from 'noddi-ui-common';

const loadingContainerVariants = {
  start: {
    transition: {
      staggerChildren: 0.2
    }
  },
  end: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const loadingCircleVariants = {
  start: {
    y: '0%'
  },
  end: {
    y: '100%'
  }
};

const loadingCircleTransition = {
  duration: 0.5,
  repeat: Infinity,
  repeatType: 'reverse' as const,
  ease: 'easeInOut'
};

// eslint-disable-next-line import/no-default-export
export default function ThreeDotsWave({ className }: { className?: string }) {
  return (
    <motion.div
      className={cn('flex size-8 justify-around', className)}
      variants={loadingContainerVariants}
      initial='start'
      animate='end'
    >
      <motion.span
        className='block size-1.5 rounded-full bg-primary'
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
      <motion.span
        className='block size-1.5 rounded-full bg-primary'
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
      <motion.span
        className='block size-1.5 rounded-full bg-primary'
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
    </motion.div>
  );
}
